const LANDING_SCROLL_ROOT_ID = 'landing-scroll-root';
const MOBILE_LANDING_MEDIA = '(max-width: 767px)';

export function scrollToLandingSection(sectionId: string): void {
  const section = document.getElementById(sectionId);
  if (!section) {
    return;
  }

  if (window.matchMedia(MOBILE_LANDING_MEDIA).matches) {
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return;
  }

  section.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export function scrollToLandingHashFromLocation(): void {
  const hash = window.location.hash.replace(/^#/, '');
  if (!hash || !document.getElementById(LANDING_SCROLL_ROOT_ID)) {
    return;
  }

  window.requestAnimationFrame(() => {
    scrollToLandingSection(hash);
  });
}
